module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_palace_b911ff6.ico";